<template>
  <div>
    <template v-if="loader">
      <img
        src="../../../../src/assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </template>
    <div v-else class="sa-review">
      <div class="sa-mob-header">
        <h5 class="sa-card-tit">
          <span class="sa-h-xs">Select follow up</span> date and slot
        </h5>
        <button class="sa-btn-back" @click="$parent.followUpViewFlag=false">
          <i class="icon-arrow-left"></i>
        </button>
      </div>
      <div class="sa-follow-arrow sa-col-xs12 sa-col-sm6 sa-col-md5 sa-col-lg4">
        <template v-if="flag"></template>
        <i v-else @click="followupInit(-1)" class="icon-left-arrow"></i>
        <span class="sa-follow-cal">
          <input
            type="text"
            class="sa-form-control sa-leave-control text-gray-700" name="follow up Date" id="followUpDate"
            v-model="date"
          />
        </span>
        <i @click="followupInit(1)" class="icon-right-arrow arrow"></i>
      </div>
      <h6 class="sa-mt20">Select Slot</h6>
      <div class="sa-select-slot" v-if="data && data[0] && data[0].slots">
          <p>12.00 Am - 6.00 Am</p>
          <ul v-if="data[0].slots.s1">
            <li v-for="(item, i) in data[0].slots.s1" :key="i">
                <span :disabled="!item.available" @click="setslots(item, i)"  :class="
                    item.available ? ((selectedslot.sltd == item.slt_id 
                    &&selectedslot.end == item.end_tym 
                    &&selectedslot.start == item.strt_tym) ? 'active' :'')  :'disabled'">{{ item.strt_tymf }}</span>
            </li>
          </ul>
          <div class="sa-no-data" v-else>
            <p>No Slots Available</p>
          </div>
      </div>
       <div class="sa-select-slot" v-if="data && data[0] && data[0].slots">
        <p>6.00 Am-12.00 Pm</p>
        <ul v-if="data[0].slots.s2">
          <li v-for="(item, i) in data[0].slots.s2" :key="i">
                <span :disabled="!item.available" @click="setslots(item, i)"  :class="
                    item.available ? ((selectedslot.sltd == item.slt_id 
                    &&selectedslot.end == item.end_tym 
                    &&selectedslot.start == item.strt_tym) ? 'active' :'')  :'disabled'">{{ item.strt_tymf }}</span>
            </li>
        </ul>
          <div class="sa-no-data" v-else>
            <p>No Slots Available</p>
          </div>
      </div>
      <div class="sa-no-data" v-else>
        <img src="../../../assets/img/page-not-found.svg" alt="Doctor Not Available" class="sa-img-responsive w-50" />
        <p>{{message}}</p>
      </div>

       <div class="sa-select-slot" v-if="data && data[0] && data[0].slots">
        <p>12.00 Pm - 6.00 Pm</p>
        <ul v-if="data[0].slots.s3">
          <li v-for="(item, i) in data[0].slots.s3" :key="i">
                <span :disabled="!item.available" @click="setslots(item, i)"  :class="
                    item.available ? ((selectedslot.sltd == item.slt_id 
                    &&selectedslot.end == item.end_tym 
                    &&selectedslot.start == item.strt_tym) ? 'active' :'')  :'disabled'">{{ item.strt_tymf }}</span>
          </li>
        </ul>
          <div class="sa-no-data" v-else>
            <p>No Slots Available</p>
          </div>
      </div>

       <div class="sa-select-slot sa-mob-cont-padbt" v-if="data && data[0] && data[0].slots">
        <p>6.00 Pm-12.00 Am</p>
        <ul v-if="data[0].slots.s4">
          <li v-for="(item, i) in data[0].slots.s4" :key="i">
               <!-- <div :class="item.available?'':'disabled'"> -->
                <span :disabled="!item.available" @click="setslots(item, i)"  :class="
                    item.available ? ((selectedslot.sltd == item.slt_id 
                    &&selectedslot.end == item.end_tym 
                    &&selectedslot.start == item.strt_tym) ? 'active' :'')  :'disabled'">{{ item.strt_tymf }}</span>
          </li>
        </ul>
          <div class="sa-no-data" v-else>
            <p>No Slots Available</p>
          </div>
      </div>
      <div class="sa-ftr-btn">
        <button @click="selectSlot"  :date="date" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" >Continue</button>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import { pro_url } from "../../../../config/endpoints";
import AddDiagnosisDetVue from './AddDiagnosisDet';
export default {
  mounted() {
    this.followupInit();
  },
  components: {
     "add-diagnosis": AddDiagnosisDetVue,
  },
  props: ["apnt","referal"],
  data() {
    return {
      date: "",
      reqDate: null,
      loader: false,
      data: [],
      message: null,
      flag:false,
      diagnosisViewFlag:false,
      selectedslot: {
				sltd: "",
				start: "",
				end: ""
			},
    };
  },
  methods: {
    followupInit(clue) {
      let _self = this;
      if (!clue) {
       this.reqDate = moment().format("YYYY-MM-DD")
      } else if(clue == 1){
        this.reqDate = moment(this.date).add(1, 'day').format('YYYY-MM-DD')
      } else {
        this.reqDate = moment(this.date).subtract(1, 'day').format('YYYY-MM-DD')
      }
      _self.loader = true;
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/followUp/browseDate`,
          body: {
            parent_apnt_id: _self.$route.params.appid,
            date: _self.reqDate,
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.data = response.data;
            _self.message = response.message;
            _self.date = this.reqDate
          }
          if(this.date== moment().format('YYYY-MM-DD')){
            this.flag=true
          }else {
            this.flag = false
            _self.date = _self.reqDate
          }
          
        });
    },
    setslots: function(item, i) {
			if (item.available) {
				if (
					this.selectedslot.sltd == item.slt_id &&
					this.selectedslot.end == item.end_tym &&
					this.selectedslot.start == item.strt_tym
				) {
					this.slotselected = false;
					this.selectedslot.sltd = "";
					this.selectedslot.start = "";
					this.selectedslot.end = "";
				} else {
					this.slotselected = true;
					this.selectedslot.sltd = item.slt_id;
					this.selectedslot.start = item.strt_tym;
					this.selectedslot.end = item.end_tym;
				}
			}
		},
    selectSlot(){
      let _self = this;
      _self.loader = true;
      _self.diagnosisViewFlag = false;
      let data = {
        date: moment(_self.date, "YYYY-MM-DD").format("DD-MMM-YYYY"),
        strt_tym: moment(this.selectedslot.start, "hh:mm").format("hh:mm A"),
        end_tym: moment(this.selectedslot.end, "hh:mm").format("hh:mm A"),
        slt_id: this.selectedslot.sltd
      }
      _self.$store
        .dispatch("httpPost", {
          uri: `${pro_url}/followUp/saveSlot`,
          body: {
            apnt_id: _self.$route.params.appid,
            date: _self.date,
            strt_tym: this.selectedslot.start,
            end_tym: this.selectedslot.end,
            slt_id: this.selectedslot.sltd
          },
        })
        .then((response) => {
          _self.loader = false;
          if (response && response.status === 1000) {
            _self.$localStorage.set('followUp', JSON.stringify(data))
            _self.data = response.data;
            if(_self.referal){
              _self.$parent.referalFlag =false
               _self.$parent.followUpViewFlag=false
               _self.$parent.init()
            }else{
            _self.diagnosisViewFlag = true
            _self.$parent.followUpViewFlag = false
             _self.$parent.height("i");
            _self.$parent.diagnosisDetails()
            }
            _self.$store.dispatch("SET_ALERTMESSAGE", {
              msg: response.message,
              class: "sa-a-success"
            });
          }
          
        })
    }
  },
};
</script>